export default "__VITE_ASSET__DSOxROsC__"